import { render, staticRenderFns } from "./DebtorReport.vue?vue&type=template&id=8785abba&scoped=true&"
import script from "./DebtorReport.vue?vue&type=script&lang=js&"
export * from "./DebtorReport.vue?vue&type=script&lang=js&"
import style0 from "./DebtorReport.vue?vue&type=style&index=0&id=8785abba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8785abba",
  null
  
)

export default component.exports